import React, { useEffect, useState } from 'react';
import { Loader } from '../../../../../../Common';
import { Button, Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import BreadcrumbTrail from '../../../../../../Common/BreadcrumbTrail';
import { useHistory } from 'react-router-dom';
import { CustomCard } from '../Comman';
import { useDispatch, useSelector } from 'react-redux';
import { GET_PROJECT_V2 } from '../../../../../../../store/actions';
import cogoToast from 'cogo-toast';
import { ChevronLeft } from 'react-feather';

const SelectProject = ({ state, setState, setFormCount }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [selectedProject, setSelectedProject] = useState(null);

  const { getProject } = useSelector((state: any) => ({
    getProject: state.GetProjectV2.data?.results?.projects,
  }));

  useEffect(() => {
    if (state?.project) {
      setSelectedProject(state?.project);
    }

    dispatch({
      type: GET_PROJECT_V2,
      payload: {
        data: {
          clientId: state?.client?.id,
        },
        urlParams: {
          pageSize: 10,
          pageIndex: 1,
        },
      },
    });
  }, []);

  /* ---------------------------- BREADCRUMB HANDLER ---------------------------- */
  const breadcrumNavigationHandler = title => {
    if (title === `Dashboard`) {
      history.push(`/dashboard`);
    }
  };

  const handleSubmit = () => {
    if (!selectedProject) {
      cogoToast.error('Please select project first');
      return;
    }
    setState(prev => ({ ...prev, project: selectedProject }));
    setFormCount((prev: number) => prev + 1);
  };

  return (
    <div className="page-content">
      <Container fluid className="position-relative">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex gap-1 align-items-center">
            <BreadcrumbTrail
              title={`Program Onboarding`}
              navigationby={breadcrumNavigationHandler}
              navigation={['Management', 'Program', 'Onboarding', 'Project List']}
            />
          </div>

          {/* <Filter
            filterHandler={filterSubmitHandler}
            bookingType={bookingType}
            approvalRequestTypeHandler={approvalRequestTypeHandler}
            modification={modification}
          /> */}
        </div>

        <Card>
          <CardHeader>
            <h5 className="m-0 fw-semibold">Select Project</h5>
          </CardHeader>
          <CardBody className="pb-5">
            <Row className="d-flex mx-1">
              {getProject?.map((project: any, index: number) => {
                const isSelected = selectedProject?.id === project.id;

                return (
                  <CustomCard
                    clientName={project.name}
                    country={''}
                    key={index}
                    selected={isSelected}
                    onClick={() => {
                      if (selectedProject?.id === project.id) {
                        cogoToast.info('Project already selected');
                        return;
                      }
                      setState(prev => ({ ...prev, project: project }));
                      setSelectedProject(prev => (prev?.id === project.id ? null : project));
                      setFormCount((prev: number) => prev + 1);
                    }}
                  />
                );
              })}
            </Row>
          </CardBody>
        </Card>
        <div className="d-flex justify-content-between">
          <Button
            onClick={() => setFormCount((prev: number) => prev - 1)}
            color="light"
            className="d-flex align-items-center gap-1 px-3 py-2"
            style={{
              backgroundColor: '#E9EBEC', // light gray
              color: '#404B7C', // navy/dark blue
              fontWeight: 500,
              boxShadow: 'none',
              border: 'none',
            }}
          >
            <ChevronLeft size={18} />
            Back
          </Button>
          <Button className="overlay-disable" style={{ width: '130px' }} color="primary" onClick={handleSubmit}>
            Continue
          </Button>
        </div>
      </Container>
    </div>
  );
};

export default SelectProject;
